export interface ISelectedHoraDate {
  date: string
  hour: string
  advisorId: string
  advisorName: string
}
